<template>
    <b-row>
        <b-col>
            <b-row v-if="row.importstatus !== '' && row.importstatus !== 'SUCCEEDED' ">
                <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
                <a @click="showDialog" style="color:blue;cursor:pointer;text-decoration:underline;">{{ row.importstatus }}</a>
            </b-row>
            <b-row v-else-if="row.importstatus === 'SUCCEEDED'" >
                <span>{{ row.importstatus }}</span>
            </b-row>
            <b-row v-else>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import ECMErrorDialog from '../modals/ECMCrawlerMessageDlg.vue';
import { showMessage} from '../../utils/commonECM.js';

export default {
    data() {
        return {
            messageDlg: false,
        }
    },
    props: ['row'],
    
    components: {
      ECMErrorDialog
    },

    created() {
        var that = this;
        const a = that;
    },

    methods: {
        showDialog() {
            var that = this;
            showMessage(this, 'error', that.row.repositoryName, that.row.importstatus, true, that.row.importstatuslog);
        }
    }
}

</script>